import React, { useState, useEffect } from 'react';
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { InquiryProvider } from './context/InquiryContext';
import { CurrencyProvider } from './context/CurrencyContext';
import { SubscriptionProvider } from './context/SubscriptionContext';
import { SocketProvider } from './context/SocketContext';
import ProtectedRoute from './components/ProtectedRoute';
import InquiryButton from './components/InquiryButton';
import InquirySidebar from './components/InquirySidebar';
import LoginModal from './components/LoginModal';
import RegisterModal from './components/RegisterModal';
import HomePage from './pages/HomePage';
import SubAdminPage from './pages/SubAdminPage/SubAdminPage';
import BuyerDirectoryPage from './pages/BuyerDirectoryPage';
import FeaturedProductsPage from './pages/FeaturedProductsPage';
import AllBrandsPage from './pages/AllBrandsPage';
import AllCategoriesPage from './pages/AllCategoriesPage';
import TopSellerPage from './pages/TopSellerPage';
import ProductListingPage from './pages/ProductListingPage';
import ProductDetailsPage from './pages/ProductDetailsPage';
import SendInquirePage from './pages/SendInquirePage';
import BuyLeadsPage from './pages/BuyLeadsPage';
import DocumentsSubmitPage from './pages/DocumentsSubmitPage';
import MembershipPackagesPage from './pages/MembershipPackagesPage';
import ProjectsPage from './pages/ProjectsPage';
import ProjectDetailsPage from './pages/ProjectDetailsPage';
import ProfessionalPage from './pages/ProfessionalPage';
import ProfessionalProfilePage from './pages/ProfessionalProfilePage';
import NewsPage from './pages/NewsPage';
import NewsDetailsPage from './pages/NewsDetailsPage';
import CompanyProfilePage from './pages/CompanyProfilePage';
import CompanyProductsPage from './pages/CompanyProductsPage';
import CompanyContactPage from './pages/CompanyContactPage';
import TermsConditionsPage from './pages/TermsConditionsPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import PrivacyPolicy2Page from './pages/PrivacyPolicy2Page';
import PrivacyPolicy3Page from './pages/PrivacyPolicy3Page';
import AboutUsPage from './pages/AboutUsPage';
import AdvertiseWithUsPage from './pages/AdvertiseWithUsPage';
import ContactUsPage from './pages/ContactUsPage';
import SellerFAQPage from './pages/SellerFAQPage';
import SellerDashboardPage from './pages/SellerDashboardPage';
import SupplierInquiriesPage from './pages/SupplierInquiriesPage';
import RFQManagePage from './pages/RFQManagePage';
import MessagePage from './pages/MessagePage';
import FavoritesSupplierPage from './pages/FavoritesSupplierPage';
import ProductManagePage from './pages/ProductManagePage';
import ProductInputPage from './pages/ProductInputPage';
import VerificationDocumentsPage from './pages/VerificationDocumentsPage';
import VerifyDocumentsPage from './pages/VerifyDocumentsPage';
import ProductInputPreviewPage from './pages/ProductInputPreviewPage';
import SpecialistManagePage from './pages/SpecialistManagePage';
import SpecialistDashboardPage from './pages/SpecialistDashboardPage';
// import SpecialistAdsManagePage from './pages/SpecialistAdsManagePage'; // temporarily removed
import BuyerFilterPage from './pages/BuyerFilterPage';
import SupplierManagePage from './pages/SupplierManagePage';
import ProjectManagePage from './pages/ProjectManagePage';
import PaymentHistoryPage from './pages/PaymentHistoryPage';
import NewsInputPage from './pages/NewsInputPage';
import ProjectInputPage from './pages/ProjectInputPage';
import ProjectInputStep2Page from './pages/ProjectInputStep2Page';
import NewsPreviewPage from './pages/NewsPreviewPage';
import SupplierProfileInfoPage from './pages/SupplierProfileInfoPage';
import SupplierProfilePage from './pages/SupplierProfilePage';
import ProfilePage from './pages/ProfilePage';
import LocationCategoryPage from './pages/LocationCategoryPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import AdminDashboard2Page from './pages/AdminDashboard2Page/AdminDashboard2Page';
import AdminProductManagePage from './pages/AdminProductManagePage';
import AdminProductDetailPage from './pages/AdminProductDetailPage/AdminProductDetailPage';
import AdminSupplierDetailPage from './pages/AdminSupplierDetailPage/AdminSupplierDetailPage';
import AdminSupplierManagePage from './pages/AdminSupplierManagePage';
import AddBrandPage from './pages/AddBrandPage';
import NewsListingPage from './pages/NewsListingPage';
// import AboutUs2Page from './pages/AboutUs2Page'; // temporarily removed
import Message2Page from './pages/Message2Page/Message2Page';
import AdminTermsConditions2Page from './pages/AdminTermsConditions2Page';
import AdminPrivacyPolicyPage from './pages/AdminPrivacyPolicyPage';
import UserManagePage from './pages/UserManagePage';
import AdminSubscribersPage from './pages/AdminSubscribersPage/AdminSubscribersPage';
import AdminSupportPage from './pages/AdminSupportPage/AdminSupportPage';
import AdminMembershipManagePage from './pages/AdminMembershipManagePage/AdminMembershipManagePage';
import AdminMembershipFormPage from './pages/AdminMembershipFormPage/AdminMembershipFormPage';
import AdminAboutUsPage from './pages/AdminAboutUsPage/AdminAboutUsPage';
import AdminAdsManagePage from './pages/AdminAdsManagePage/AdminAdsManagePage';
import AdminVerificationManagePage from './pages/AdminVerificationManagePage/AdminVerificationManagePage';
import AdminProfilePage from './pages/AdminProfilePage/AdminProfilePage';
import SubcategoryPage from './pages/SubcategoryPage/SubcategoryPage';
import './App.css';

// Component to reset scroll and body overflow on route change
function ScrollReset() {
  const location = useLocation();
  
  useEffect(() => {
    // Reset body overflow to allow scrolling on route change
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
    // Scroll to top on route change
    window.scrollTo(0, 0);
  }, [location.pathname]);
  
  return null;
}

function App() {
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showRegisterModal, setShowRegisterModal] = useState(false);

  const handleLoginRequired = () => {
    setShowLoginModal(true);
  };

  const handleRegisterClick = () => {
    setShowLoginModal(false);
    setShowRegisterModal(true);
  };

  const handleLoginClick = () => {
    setShowRegisterModal(false);
    setShowLoginModal(true);
  };

  return (
    <AuthProvider>
      <SocketProvider>
      <SubscriptionProvider>
      <CurrencyProvider>
      <InquiryProvider>
      <div className="App">
        <ScrollReset />
        <Routes>
          <Route path="/" element={<HomePage />} />
          {/* TEMPORARILY HIDDEN - Buyer Directory, Buy Leads, Projects, Specialists
          <Route path="/buyer-directory" element={<BuyerDirectoryPage />} />
          */}
          <Route path="/buyer-directory" element={<HomePage />} />
        <Route path="/featured-products" element={<FeaturedProductsPage />} />
        <Route path="/all-brands" element={<AllBrandsPage />} />
        <Route path="/all-categories" element={<AllCategoriesPage />} />
        <Route path="/top-seller" element={<TopSellerPage />} />
        <Route path="/top-sellers" element={<TopSellerPage />} />
        <Route path="/suppliers" element={<TopSellerPage />} />
        <Route path="/sellers" element={<TopSellerPage />} />
        <Route path="/products" element={<ProductListingPage />} />
        <Route path="/products/:category" element={<ProductListingPage />} />
        <Route path="/category/:categorySlug" element={<SubcategoryPage />} />
        <Route path="/category/:categorySlug/:subcategorySlug" element={<SubcategoryPage />} />
        <Route path="/product/:id" element={<ProductDetailsPage />} />
        <Route path="/product-details" element={<ProductDetailsPage />} />
        <Route path="/send-inquire" element={<ProtectedRoute><SendInquirePage /></ProtectedRoute>} />
        <Route path="/send-inquire/:id" element={<ProtectedRoute><SendInquirePage /></ProtectedRoute>} />
        {/* TEMPORARILY HIDDEN - Buy Leads
        <Route path="/buy-leads" element={<BuyLeadsPage />} />
        */}
        <Route path="/buy-leads" element={<HomePage />} />
        <Route path="/documents-submit" element={<ProtectedRoute><DocumentsSubmitPage /></ProtectedRoute>} />
        <Route path="/membership-packages" element={<ProtectedRoute><MembershipPackagesPage /></ProtectedRoute>} />
        {/* TEMPORARILY HIDDEN - Projects
        <Route path="/projects" element={<ProjectsPage />} />
        */}
        <Route path="/projects" element={<HomePage />} />
        <Route path="/project/:id" element={<ProjectDetailsPage />} />
        <Route path="/project-details" element={<ProjectDetailsPage />} />
        <Route path="/professionals" element={<ProfessionalPage />} />
        {/* TEMPORARILY HIDDEN - Specialists
        <Route path="/specialists" element={<ProfessionalPage />} />
        */}
        <Route path="/specialists" element={<HomePage />} />
        <Route path="/professional/:id" element={<ProfessionalProfilePage />} />
        <Route path="/professional-profile" element={<ProfessionalProfilePage />} />
        <Route path="/news" element={<NewsPage />} />
        <Route path="/news/:id" element={<NewsDetailsPage />} />
        <Route path="/news-details" element={<NewsDetailsPage />} />
        <Route path="/company-profile" element={<CompanyProfilePage />} />
        <Route path="/company-profile/:id" element={<CompanyProfilePage />} />
        <Route path="/seller/:id" element={<CompanyProfilePage />} />
        <Route path="/company-products" element={<CompanyProductsPage />} />
        <Route path="/company-products/:id" element={<CompanyProductsPage />} />
        <Route path="/company-contact" element={<CompanyContactPage />} />
        <Route path="/privacy-policy-2" element={<PrivacyPolicy2Page />} />
        <Route path="/admin/privacy-policy" element={<PrivacyPolicy2Page />} />
        <Route path="/privacy-policy-3" element={<PrivacyPolicy3Page />} />
        <Route path="/admin/privacy-policy-3" element={<PrivacyPolicy3Page />} />
        <Route path="/about-us" element={<AboutUsPage />} />
        <Route path="/about-us" element={<AboutUsPage />} />
        <Route path="/supplier/:id" element={<CompanyProfilePage />} />
        <Route path="/supplier/:id/profile" element={<CompanyProfilePage />} />
        <Route path="/supplier/:id/products" element={<CompanyProfilePage />} />
        <Route path="/supplier/:id/contact" element={<CompanyProfilePage />} />
        <Route path="/terms-conditions" element={<TermsConditionsPage />} />
        <Route path="/terms" element={<TermsConditionsPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/about-us" element={<AboutUsPage />} />
        <Route path="/about" element={<AboutUsPage />} />
        {/* <Route path="/about-us-2" element={<AboutUs2Page />} /> */}
        {/* <Route path="/admin/about-us" element={<AboutUs2Page />} /> */}
        <Route path="/contact-us" element={<ContactUsPage />} />
        <Route path="/contact" element={<ContactUsPage />} />
        <Route path="/advertise-with-us" element={<AdvertiseWithUsPage />} />
        <Route path="/advertise" element={<AdvertiseWithUsPage />} />
        <Route path="/seller-faq" element={<SellerFAQPage />} />
        <Route path="/seller-faqs" element={<SellerFAQPage />} />
        <Route path="/seller-dashboard" element={<ProtectedRoute><SellerDashboardPage /></ProtectedRoute>} />
        <Route path="/dashboard" element={<ProtectedRoute><SellerDashboardPage /></ProtectedRoute>} />
        <Route path="/supplier-inquiries" element={<ProtectedRoute><SupplierInquiriesPage /></ProtectedRoute>} />
        <Route path="/rfq-manage" element={<ProtectedRoute><RFQManagePage /></ProtectedRoute>} />
        <Route path="/rfq" element={<ProtectedRoute><RFQManagePage /></ProtectedRoute>} />
        <Route path="/messages" element={<ProtectedRoute><MessagePage /></ProtectedRoute>} />
        <Route path="/inbox" element={<ProtectedRoute><MessagePage /></ProtectedRoute>} />
        <Route path="/favorites-supplier" element={<ProtectedRoute><FavoritesSupplierPage /></ProtectedRoute>} />
        <Route path="/favorites" element={<ProtectedRoute><FavoritesSupplierPage /></ProtectedRoute>} />
        <Route path="/saved-suppliers" element={<ProtectedRoute><FavoritesSupplierPage /></ProtectedRoute>} />
        <Route path="/following" element={<ProtectedRoute><FavoritesSupplierPage /></ProtectedRoute>} />
        <Route path="/product-manage" element={<ProtectedRoute><ProductManagePage /></ProtectedRoute>} />
        <Route path="/product-input" element={<ProtectedRoute><ProductInputPage /></ProtectedRoute>} />
        <Route path="/add-product" element={<ProtectedRoute><ProductInputPage /></ProtectedRoute>} />
        <Route path="/create-product" element={<ProtectedRoute><ProductInputPage /></ProtectedRoute>} />
        <Route path="/verification-documents" element={<ProtectedRoute><VerificationDocumentsPage /></ProtectedRoute>} />
        <Route path="/verify-documents-old" element={<ProtectedRoute><VerificationDocumentsPage /></ProtectedRoute>} />
        <Route path="/verify-documents" element={<ProtectedRoute><VerifyDocumentsPage /></ProtectedRoute>} />
        <Route path="/specialist-manage" element={<ProtectedRoute><SpecialistManagePage /></ProtectedRoute>} />
        {/* <Route path="/specialist-ads-manage" element={<SpecialistAdsManagePage />} /> */}
        {/* <Route path="/specialist/ads" element={<SpecialistAdsManagePage />} /> */}
        <Route path="/buyer-filter" element={<ProtectedRoute><BuyerFilterPage /></ProtectedRoute>} />
        {/* Admin Routes - Protected */}
        <Route path="/admin" element={<ProtectedRoute requireAdmin><AdminDashboard2Page /></ProtectedRoute>} />
        <Route path="/admin/dashboard" element={<ProtectedRoute requireAdmin><AdminDashboard2Page /></ProtectedRoute>} />
        <Route path="/admin/dashboard-old" element={<ProtectedRoute requireAdmin><AdminDashboardPage /></ProtectedRoute>} />
        <Route path="/admin/news" element={<ProtectedRoute requireAdmin><NewsListingPage /></ProtectedRoute>} />
        <Route path="/admin/news-listing" element={<ProtectedRoute requireAdmin><NewsListingPage /></ProtectedRoute>} />
        <Route path="/admin/product-manage" element={<ProtectedRoute requireAdmin><AdminProductManagePage /></ProtectedRoute>} />
        <Route path="/admin/products" element={<ProtectedRoute requireAdmin><AdminProductManagePage /></ProtectedRoute>} />
        <Route path="/admin/products/:id" element={<ProtectedRoute requireAdmin><AdminProductDetailPage /></ProtectedRoute>} />
        <Route path="/admin/product-detail/:id" element={<ProtectedRoute requireAdmin><AdminProductDetailPage /></ProtectedRoute>} />
        <Route path="/supplier-profile-info" element={<ProtectedRoute><SupplierProfileInfoPage /></ProtectedRoute>} />
        <Route path="/profile" element={<ProtectedRoute><SupplierProfileInfoPage /></ProtectedRoute>} />
        <Route path="/my-profile" element={<ProtectedRoute><SupplierProfileInfoPage /></ProtectedRoute>} />
        <Route path="/supplier-profile" element={<ProtectedRoute><SupplierProfileInfoPage /></ProtectedRoute>} />
        <Route path="/news-input" element={<ProtectedRoute requireAdmin><NewsInputPage /></ProtectedRoute>} />
        <Route path="/admin/news/add" element={<ProtectedRoute requireAdmin><NewsInputPage /></ProtectedRoute>} />
        <Route path="/admin/news/edit/:id" element={<ProtectedRoute requireAdmin><NewsInputPage /></ProtectedRoute>} />
        <Route path="/admin/news/input" element={<ProtectedRoute requireAdmin><NewsInputPage /></ProtectedRoute>} />
        <Route path="/news-preview" element={<ProtectedRoute requireAdmin><NewsPreviewPage /></ProtectedRoute>} />
        <Route path="/admin/news/preview" element={<ProtectedRoute requireAdmin><NewsPreviewPage /></ProtectedRoute>} />
        <Route path="/payment-history" element={<ProtectedRoute requireAdmin><PaymentHistoryPage /></ProtectedRoute>} />
        <Route path="/admin/payment-history" element={<ProtectedRoute requireAdmin><PaymentHistoryPage /></ProtectedRoute>} />
        <Route path="/admin/payments" element={<ProtectedRoute requireAdmin><PaymentHistoryPage /></ProtectedRoute>} />
        <Route path="/supplier-manage" element={<ProtectedRoute requireAdmin><SupplierManagePage /></ProtectedRoute>} />
        <Route path="/admin/suppliers" element={<ProtectedRoute requireAdmin><AdminSupplierManagePage /></ProtectedRoute>} />
        <Route path="/admin/suppliers/:id" element={<ProtectedRoute requireAdmin><AdminSupplierDetailPage /></ProtectedRoute>} />
        <Route path="/admin/supplier-manage" element={<ProtectedRoute requireAdmin><AdminSupplierManagePage /></ProtectedRoute>} />
        <Route path="/project-manage" element={<ProtectedRoute requireAdmin><ProjectManagePage /></ProtectedRoute>} />
        <Route path="/admin/projects" element={<ProtectedRoute requireAdmin><ProjectManagePage /></ProtectedRoute>} />
        <Route path="/admin/project-manage" element={<ProtectedRoute requireAdmin><ProjectManagePage /></ProtectedRoute>} />
        <Route path="/project-input" element={<ProtectedRoute requireAdmin><ProjectInputPage /></ProtectedRoute>} />
        <Route path="/project-input-step2" element={<ProtectedRoute requireAdmin><ProjectInputStep2Page /></ProtectedRoute>} />
        <Route path="/project-input/step2" element={<ProtectedRoute requireAdmin><ProjectInputStep2Page /></ProtectedRoute>} />
        <Route path="/location-category" element={<ProtectedRoute requireAdmin><LocationCategoryPage /></ProtectedRoute>} />
        <Route path="/admin/location-category" element={<ProtectedRoute requireAdmin><LocationCategoryPage /></ProtectedRoute>} />
        <Route path="/admin/locations" element={<ProtectedRoute requireAdmin><LocationCategoryPage /></ProtectedRoute>} />
        <Route path="/sub-admin" element={<ProtectedRoute requireAdmin><SubAdminPage /></ProtectedRoute>} />
        <Route path="/admin/sub-admin" element={<ProtectedRoute requireAdmin><SubAdminPage /></ProtectedRoute>} />
        <Route path="/admin/roles" element={<ProtectedRoute requireAdmin><SubAdminPage /></ProtectedRoute>} />
        <Route path="/admin/add-brand" element={<ProtectedRoute requireAdmin><AddBrandPage /></ProtectedRoute>} />
        <Route path="/admin/brands/add" element={<ProtectedRoute requireAdmin><AddBrandPage /></ProtectedRoute>} />
        <Route path="/add-brand" element={<ProtectedRoute requireAdmin><AddBrandPage /></ProtectedRoute>} />
        <Route path="/message2" element={<ProtectedRoute requireAdmin><Message2Page /></ProtectedRoute>} />
        <Route path="/messages2" element={<ProtectedRoute requireAdmin><Message2Page /></ProtectedRoute>} />
        <Route path="/admin/messages" element={<ProtectedRoute requireAdmin><Message2Page /></ProtectedRoute>} />
        <Route path="/admin/inbox" element={<ProtectedRoute requireAdmin><Message2Page /></ProtectedRoute>} />
        <Route path="/admin/terms-conditions" element={<ProtectedRoute requireAdmin><AdminTermsConditions2Page /></ProtectedRoute>} />
        <Route path="/admin/terms" element={<ProtectedRoute requireAdmin><AdminTermsConditions2Page /></ProtectedRoute>} />
        <Route path="/admin/privacy-policy" element={<ProtectedRoute requireAdmin><AdminPrivacyPolicyPage /></ProtectedRoute>} />
        <Route path="/admin/privacy" element={<ProtectedRoute requireAdmin><AdminPrivacyPolicyPage /></ProtectedRoute>} />
        <Route path="/admin/users" element={<ProtectedRoute requireAdmin><UserManagePage /></ProtectedRoute>} />
        <Route path="/admin/user-manage" element={<ProtectedRoute requireAdmin><UserManagePage /></ProtectedRoute>} />
        <Route path="/admin/verify-documents" element={<ProtectedRoute requireAdmin><AdminVerificationManagePage /></ProtectedRoute>} />
        <Route path="/admin/verification" element={<ProtectedRoute requireAdmin><AdminVerificationManagePage /></ProtectedRoute>} />
        <Route path="/admin/membership" element={<ProtectedRoute requireAdmin><AdminMembershipManagePage /></ProtectedRoute>} />
        <Route path="/admin/membership-packages" element={<ProtectedRoute requireAdmin><AdminMembershipManagePage /></ProtectedRoute>} />
        <Route path="/admin/membership/create" element={<ProtectedRoute requireAdmin><AdminMembershipFormPage /></ProtectedRoute>} />
        <Route path="/admin/membership/edit/:id" element={<ProtectedRoute requireAdmin><AdminMembershipFormPage /></ProtectedRoute>} />
        <Route path="/admin/ads" element={<ProtectedRoute requireAdmin><AdminAdsManagePage /></ProtectedRoute>} />
        <Route path="/admin/advertise" element={<ProtectedRoute requireAdmin><AdminAdsManagePage /></ProtectedRoute>} />
        <Route path="/admin/support" element={<ProtectedRoute requireAdmin><AdminSupportPage /></ProtectedRoute>} />
        <Route path="/admin/contact" element={<ProtectedRoute requireAdmin><AdminSupportPage /></ProtectedRoute>} />
        <Route path="/admin/about-us" element={<ProtectedRoute requireAdmin><AdminAboutUsPage /></ProtectedRoute>} />
        <Route path="/admin/profile" element={<ProtectedRoute requireAdmin><AdminProfilePage /></ProtectedRoute>} />
        <Route path="/admin/settings" element={<ProtectedRoute requireAdmin><AdminDashboardPage /></ProtectedRoute>} />
        <Route path="/admin/subscribers" element={<ProtectedRoute requireAdmin><AdminSubscribersPage /></ProtectedRoute>} />
        </Routes>
        <InquiryButton />
        <InquirySidebar onLoginRequired={handleLoginRequired} />
        <LoginModal 
          isOpen={showLoginModal}
          onClose={() => setShowLoginModal(false)}
          onRegisterClick={handleRegisterClick}
        />
        <RegisterModal 
          isOpen={showRegisterModal}
          onClose={() => setShowRegisterModal(false)}
          onLoginClick={handleLoginClick}
        />
      </div>
      </InquiryProvider>
      </CurrencyProvider>
      </SubscriptionProvider>
      </SocketProvider>
    </AuthProvider>
  );
}

export default App;
